module.exports = __webpack_public_path__ + "img/11-2.84db4108.jpg";